import { render, staticRenderFns } from "./Questions.container.vue?vue&type=template&id=c45faf5c&scoped=true&"
import script from "./Questions.container.vue?vue&type=script&lang=js&"
export * from "./Questions.container.vue?vue&type=script&lang=js&"
import style0 from "./Questions.container.vue?vue&type=style&index=0&id=c45faf5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45faf5c",
  null
  
)

export default component.exports